var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Avatar, Card, Col, Flex, Grid, Row, Typography, theme } from "antd";
import { useNavigate } from "react-router-dom";
import LiveStatusBox from "./../../../../liveStatusBox/LiveStatusBox.js";
import VideoBox from "./../../../../videoBox/VideoBox.js";
import dayjs from "dayjs";
import FavoritesComponent from "./../../../../favoritesComponent/FavoritesComponent.js";
import { FAVORITE_CATEGORIES } from "./../../../../favoritesComponent/favoritesService.js";
import { ReactComponent as SummaryRed } from "./../../../../../assets/icons/summary/summary_red.svg";
const { Text } = Typography;
const { useBreakpoint } = Grid;
const Fixture = ({
  fixture,
  fixtureClickCallback,
  showStartDate,
  onFavoriteToggle
}) => {
  var _a, _b, _c, _d;
  const { token } = theme.useToken();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const boxStyle = {
    backgroundColor: token.colorBgSolid,
    borderRadius: token.borderRadiusXXS,
    padding: "2px 8px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minWidth: 20
  };
  const timeStateBoxStyle = {
    borderRadius: token.borderRadiusXXS,
    color: token.colorTextBase,
    width: screens.md ? 54 : 48,
    height: 26,
    fontSize: screens.md ? token.fontSizeLG : token.fontSize,
    fontFamily: token.secondaryFontFamily,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: token.colorBgSolid
  };
  const timeScoreTextStyle = {
    fontFamily: token.secondaryFontFamily,
    fontSize: token.fontSize,
    fontWeight: 500,
    color: token.colorTextBase,
    lineHeight: "22px"
  };
  const onFixtureClick = (e) => {
    e.stopPropagation();
    fixtureClickCallback == null ? void 0 : fixtureClickCallback();
    navigate(`/fixture/${fixture.id}`);
  };
  return /* @__PURE__ */ jsx(
    Card,
    {
      size: "small",
      className: "fixture-card",
      style: {
        borderRadius: token.borderRadiusXS,
        cursor: "pointer",
        border: "none",
        borderBottom: "none",
        color: token.colorTextBase,
        boxShadow: "none",
        padding: screens.md ? "10px 16px" : "10px"
      },
      onClick: onFixtureClick,
      children: /* @__PURE__ */ jsxs(
        Row,
        {
          align: "middle",
          gutter: screens.md ? [16, 16] : [10, 10],
          style: { cursor: "pointer", flexFlow: "nowrap" },
          children: [
            /* @__PURE__ */ jsxs(Flex, { vertical: true, align: "center", gap: 4, children: [
              showStartDate && (fixture == null ? void 0 : fixture.startingAt) && !(fixture == null ? void 0 : fixture.isLive) && /* @__PURE__ */ jsx(Text, { style: { fontSize: token.fontSizeXS }, children: dayjs(fixture.startingAt).format("DD.MM.YY") }),
              fixture.isFinished && /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(
                "div",
                {
                  style: __spreadProps(__spreadValues({}, timeStateBoxStyle), {
                    border: "solid 1px",
                    borderColor: token.colorNatural
                  }),
                  children: /* @__PURE__ */ jsx(Text, { style: timeScoreTextStyle, children: fixture.currentTimeState })
                }
              ) }),
              fixture.isLive && /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(
                LiveStatusBox,
                {
                  minutes: fixture.currentTimeState,
                  style: {
                    width: timeStateBoxStyle.width,
                    display: "flex",
                    justifyContent: "center"
                  }
                }
              ) }),
              !fixture.isLive && !fixture.isFinished && /* @__PURE__ */ jsx(Col, { style: { display: "flex", flexShrink: 0 }, children: /* @__PURE__ */ jsx(
                Flex,
                {
                  style: __spreadValues({}, timeStateBoxStyle),
                  children: /* @__PURE__ */ jsx(Text, { style: timeScoreTextStyle, children: dayjs(fixture.startingAt).format("HH:mm") })
                }
              ) })
            ] }),
            /* @__PURE__ */ jsx(Col, { flex: "auto", children: /* @__PURE__ */ jsxs(Flex, { gap: 8, vertical: true, children: [
              /* @__PURE__ */ jsxs(Flex, { gap: 10, children: [
                /* @__PURE__ */ jsx(
                  Avatar,
                  {
                    src: fixture == null ? void 0 : fixture.home.iconUrl,
                    shape: "square",
                    style: {
                      borderRadius: 0,
                      height: 22,
                      width: 22,
                      flexShrink: 0
                    }
                  }
                ),
                /* @__PURE__ */ jsxs(Flex, { gap: 6, align: "center", children: [
                  /* @__PURE__ */ jsx(
                    Text,
                    {
                      style: {
                        color: token.colorTextBase,
                        fontSize: token.fontSizeSM
                      },
                      children: (_a = fixture == null ? void 0 : fixture.home) == null ? void 0 : _a.displayName
                    }
                  ),
                  ((_b = fixture == null ? void 0 : fixture.home) == null ? void 0 : _b.redCardsCount) > 0 && /* @__PURE__ */ jsx(SummaryRed, { style: { height: 12 } })
                ] })
              ] }),
              /* @__PURE__ */ jsxs(Flex, { gap: 10, children: [
                /* @__PURE__ */ jsx(
                  Avatar,
                  {
                    src: (_c = fixture == null ? void 0 : fixture.away) == null ? void 0 : _c.iconUrl,
                    shape: "square",
                    style: {
                      borderRadius: 0,
                      height: 22,
                      width: 22,
                      flexShrink: 0
                    }
                  }
                ),
                /* @__PURE__ */ jsxs(Flex, { gap: 6, align: "center", children: [
                  /* @__PURE__ */ jsx(
                    Text,
                    {
                      style: {
                        color: token.colorTextBase,
                        fontSize: token.fontSizeSM
                      },
                      children: fixture.away.displayName
                    }
                  ),
                  ((_d = fixture == null ? void 0 : fixture.away) == null ? void 0 : _d.redCardsCount) > 0 && /* @__PURE__ */ jsx(SummaryRed, { style: { height: 12 } })
                ] })
              ] })
            ] }) }),
            (fixture.externalHostingVideoId || fixture.videoUrl) && /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(
              VideoBox,
              {
                videoId: fixture.externalHostingVideoId,
                videoPublicUrl: fixture.videoUrl,
                videoType: fixture.videoType,
                style: { width: "77px" }
              }
            ) }),
            fixture.home.score && fixture.away.score && /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(Flex, { vertical: true, gap: 2, style: boxStyle, children: /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                Text,
                {
                  style: __spreadProps(__spreadValues({}, timeScoreTextStyle), {
                    fontSize: token.fontSizeLG
                  }),
                  children: fixture.home.score
                }
              ),
              /* @__PURE__ */ jsx(
                Text,
                {
                  style: __spreadProps(__spreadValues({}, timeScoreTextStyle), {
                    fontSize: token.fontSizeLG
                  }),
                  children: fixture.away.score
                }
              )
            ] }) }) }),
            /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(
              FavoritesComponent,
              {
                category: FAVORITE_CATEGORIES.MATCH,
                itemId: fixture.id,
                isFavorite: fixture.isFavorite,
                disabled: fixture.isFinished,
                callback: onFavoriteToggle
              }
            ) }) })
          ]
        }
      )
    }
  );
};
var stdin_default = memo(Fixture);
export {
  stdin_default as default
};
